import * as actionTypes from '../actions/actionTypes'
import * as actionStatuses from '../actions/actionStatuses'
//@ts-ignore
import objectPath from 'object-path';

export default function reduce(state = {}, action: any) {
    let stateLocation;
    switch (action.type) {
        case actionTypes.STAGE_GET_INIT_DATA:
            let input = action.payload.input;
            let newState = Object.assign({}, state);
            objectPath.set(newState, action.payload.stateLocation, { input });
            return newState;

        case actionTypes.SEND_GET_INIT_DATA:
            switch (action.status) {
                case actionStatuses.begin:
                    return state;

                case actionStatuses.complete:
                    let responseLoc = action.payload.stateLocation;

                    let response = Object.assign({
                        messageType: action.payload.messageType,
                        messageSource: action.payload.messageSource,
                        response: action.payload.response
                    });

                    if (action.error) {
                        response = {
                            error: true,
                            message: action.payload.response
                        };
                    }

                    newState = Object.assign({}, state);
                    objectPath.set(newState, responseLoc, response);

                    return newState;

                default:
                    return state;
            }

        case actionTypes.SAVE_INIT_DATA_FLAG:
            let initDataRetrieved = action.payload.initDataRetrieved;
            newState = Object.assign({}, state);
            objectPath.set(newState, action.payload.stateLocation, initDataRetrieved);
            return newState;


        case actionTypes.SAVE_INIT_DATA:
            newState = Object.assign({}, state);
            objectPath.set(newState, action.payload.initDataBaseLocation, action.payload.initDataInput);
            return newState;

        case actionTypes.SAVE_PRE_AUTH_INIT_DATA:
            newState = Object.assign({}, state);
            objectPath.set(newState, action.payload.preAuthInitDataLocation, action.payload.preAuthInitDataInput);
            return newState;

        case actionTypes.SAVE_PRODUCT_PAYLOAD:
            stateLocation = action.payload.stateLocation;
            let productPayload = action.payload.productPayload;
            productPayload[action.payload.productSavedLocation] = true;
            newState = Object.assign({}, state);
            objectPath.set(newState, action.payload.stateLocation, productPayload);
            return newState;

        case actionTypes.SAVE_USER_ADVOCACY_AVAILABILITY:
            newState = Object.assign({}, state);
            objectPath.set(newState, action.payload.stateLocation, action.payload.value);
            return newState;

        case actionTypes.SET_USER_INITIALIZE_COMPLETE:
            newState = Object.assign({}, state);
            objectPath.set(newState, action.payload.stateLocation, true);
            return newState;

        default:
            return state;

    }
}



// WEBPACK FOOTER //
// ./modules/initialization-data-handler/reducers/index.ts